import React from "react";
import classes from "./Item.module.css";

function Item(props) {
    return (
    <div className={classes.main}>
        <input type='checkbox'
            checked={props.value} 
            onChange={props.onChange}/>
        <span title={props.title}>
            {props.title}
        </span>
    </div>)
}

export default Item;